export default __webpack_public_path__ + "static/media/it-takes-an-island.688a64a0.mp4";